import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const affiliateHref = (value) => {
  try {
    const url = new URL(value);
    return ['https:', 'http:'].includes(url.protocol) ? value : null;
  } catch {
    return null;
  }
};

export const CampaignBrokerActions = ({ broker, featured }) => {
  const href = affiliateHref(broker.affiliate_url);
  return (
    <div className="campaign-actions">
      {href ? (
        <Button asChild className={`campaign-visit ${featured ? 'campaign-visit-featured' : 'campaign-visit-peer'}`}>
          <a href={href} target="_blank" rel="noopener noreferrer nofollow sponsored"
            aria-label={`Visit ${broker.name} (affiliate link, opens in a new tab)`}
            data-testid={`campaign-visit-${broker.slug}`}>
            {featured ? `Visit ${broker.name}` : 'Visit Broker'} <ArrowRight aria-hidden="true" />
          </a>
        </Button>
      ) : (
        <p className="text-sm text-slate-500" data-testid={`campaign-link-unavailable-${broker.slug}`}>Visit link unavailable</p>
      )}
      <Link to={`/${broker.slug}`} className="campaign-review" data-testid={`campaign-review-${broker.slug}`}>
        {featured ? 'Read Full Review' : 'Read Review'}
      </Link>
      <p className="campaign-link-disclosure" data-testid={`campaign-affiliate-${broker.slug}`}>
        Affiliate link. We may receive compensation if you register.
      </p>
      <p className="campaign-link-risk" data-testid={`campaign-risk-${broker.slug}`}>
        Leveraged trading is high risk. Your capital is at risk.
      </p>
    </div>
  );
};